import { Component, OnInit, AfterViewInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import Cropper from 'cropperjs';
import $ from 'jquery';
import { CommonHttpService } from 'src/app/shared/services/common-http/common-http.service';
import { Options } from '@angular-slider/ngx-slider';
import { Subject } from 'rxjs';
import { CommunicationService } from 'src/app/shared/services/communication/communication.service';

@Component({
    selector: 'app-challenge-cropper-modal',
    templateUrl: './challenge-cropper-modal.component.html',
    styleUrls: ['./challenge-cropper-modal.component.scss'],
    standalone: false
})
export class ChallengeCropperModalComponent implements OnInit, AfterViewInit {

  // controls for toggling editables
  cropper: Cropper;
  modelRef1: BsModalRef;
  onclose = new Subject();
  currProfileAssetId: any;
  profileAssetId: number;
  eventpreview: object = null;
  initialFormValues: object = null;
  isFirstTime = true;
  currentAssetId: number;
  defaultBlob: any;
  oldValue = 0;
  value = 0;
  imgReader: any;
  options: Options = {
    floor: 0,
    ceil: 100,
    showSelectionBar: true,
    getPointerColor: (): string => {
      return '#ff7e00';
    }
  };

  constructor(
    private commonHttpService: CommonHttpService,
    private communicationService: CommunicationService
  ) { }

  ngOnInit() {
    this.communicationService.setShowHideLoader({ loaderId: 'simpleLoader', text: '', isShow: true });
    this.isFirstTime = true;
    this.intializeCropperForPreSetImage();
  }

  ngAfterViewInit() {
  }
  /**
   * To initialize the profile image
   */
  intializeCropperForPreSetImage() {
    $('#crop-file-upload').val('');
    $('#uploadedImage').attr('src', '');
    const $previews = $('.preview');
    $previews.html('');
    if (this.currProfileAssetId) {
      $('#uploadedImage').attr('src', this.imgReader);
      this.cropperInitializer();
    } else {
      $('#uploadedImage').attr('src', 'assets/img/NoImage.png');
      this.cropperInitializer();
    }
  }


  /**
   * Conditional initialization requirement for firefox browser
   */
  cropperInitializer() {
    setTimeout(() => {
      this.initializeCropper();
    });
  }
  zoomImg(e) {
    if (!e) {
      this.cropper.zoom(0);
    } else if (e === 100) {
      this.cropper.zoom(1);
    } else {
      this.cropper.zoom(0.01 * (e - this.oldValue));
    }
    this.oldValue = e;
  }
  zoomExact(zoomValue) {
    this.cropper.zoom(zoomValue);
    if ((this.value !== 0 && zoomValue < 0) && (this.value !== 100 && zoomValue > 0)) {
      this.value += zoomValue * 100;
    }
  }
  /**
   * To set the image cropper along with its css and config
   */
  initializeCropper() {
    const $previews = $('.preview');
    const img = document.getElementById('uploadedImage') as HTMLImageElement;
    const self = this;
    this.cropper = new Cropper(img, {
      ready() {
        const $clone = $(this).clone().removeClass('cropper-hidden') as any;
        $clone.css({
          display: 'block',
          width: '100%',
          height: '100%',
          minWidth: 0,
          minHeight: 0,
          maxWidth: 'none',
          maxHeight: 'none',
        });
        $previews.css({
          width: '100%',
          overflow: 'hidden'
        }).html($clone);
      },
      viewMode: 3,
      aspectRatio: 5,
      crop: (e) => {
        this.eventpreview = e.detail;
        $('#position-x').val(e.detail.x);
        $('#position-y').val(e.detail.y);
        $('#cropper-height').val(e.detail.height);
        $('#cropper-width').val(e.detail.width);
        if (this.isFirstTime) {
          this.isFirstTime = false;
          this.communicationService.setShowHideLoader({ loaderId: 'simpleLoader', text: '', isShow: false });
        }
      },
      dragMode: 'move',
      autoCropArea: 1,
      zoomable: true,
      zoomOnTouch: false,
      zoomOnWheel: false,
      cropBoxResizable: false,
      minCropBoxWidth: 150,
      minCropBoxHeight: 50,
      toggleDragModeOnDblclick: false
    });
  }

  closeSelectionModal() {
    this.onclose.next(null);
  }

  saveChallengeImage() {
    this.communicationService.setShowHideLoader({ loaderId: 'simpleLoader', text: '', isShow: true });
    this.cropper.getCroppedCanvas().toBlob((blob: any) => {
      const formData = new FormData();
      formData.append('file', blob);
      this.commonHttpService.post(
        {
          uri: '/api/Assets/UploadResource',
          object: formData
        }).subscribe((response) => {
          this.onclose.next(response);
          this.communicationService.setShowHideLoader({ loaderId: 'simpleLoader', text: '', isShow: false });
        });
    });
  }

  btnDisableCondition() {
    const uploadedFile = $('#crop-file-upload').get(0) as any;
    if (uploadedFile.files && uploadedFile.files.length > 0) {
      return false;
    }
    return true;
  }
}
